<template>
  <div>
    <div class="bet-qs">
      <div class="bet-1">
        <DoublePlayer
          class="item-bet-1"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.P_DUAL"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <TieComponent
          class="item-bet-2"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.TIE"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <DoubleBanker
          class="item-bet-3"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.B_DUAL"
          :current-chip="currentChip"
          :game-state="gameState"
        />
      </div>
      <div class="bet-2">
        <PlayerComponent
          class="item-bet-4"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.PLAYER"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <BankerComponent
          class="item-bet-5"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.BANKER"
          :current-chip="currentChip"
          :game-state="gameState"
        />
      </div>
    </div>
    <div class="img-bet-qs" :class="css" ></div>
    <div class="bet-success" :class="{ active: isSucceed === true }"><span>Thành công</span></div>
  </div>
</template>

<script>
import PlayerComponent from '@components/baccarat/buttons/player.vue';
import TieComponent from '@components/baccarat/buttons/tie.vue';
import BankerComponent from '@components/baccarat/buttons/banker.vue';
import DoublePlayer from '@components/baccarat/buttons/double-player.vue';
import DoubleBanker from '@components/baccarat/buttons/double-banker.vue';
import { GAMESTATE } from '@config/constants.js';

export default {
  components: {
    PlayerComponent,
    TieComponent,
    BankerComponent,
    DoublePlayer,
    DoubleBanker,
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    round: { type: Number, default: 0 },
    score: { type: Object, default: () => ({})},
    data: { type: Object, default: () => ({})},
    odds: { type: Object, default: () => ({})},
    isHighlightResult: Boolean,
    currentChip: { type: Number, default: 0 },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
  },
  data() {
    return {
      isSucceed: false,
      css: "",
    }
  },
  watch: { 
    '$i18n.locale': function(newVal, oldVal) {
      if(newVal !== 'vn') {
        this.css = `img-bet-qs-${newVal}`;
      } else {
        this.css = "";
      }
      console.log('$i18n.locale', newVal);
    }
  }
}
</script>

<style>

</style>
